// extracted by mini-css-extract-plugin
export default {"wrap":"DayCounter_wrap__nySGJ","headline":"DayCounter_headline__r3tQ3"};